import React, { useContext, useState } from "react";
import { RicosContext } from "./../../../ricos-context/index.js";
import {
  getIsModalOpen,
  useModalService,
  useModalState
} from "./../../../ricos-modals/modal-service-provider.js";
import { DividerData_Width } from "./../../../ricos-schema/legacy/wix/rich_content/v1/index.js";
import { SizeMediumIcon } from "./../../../plugin-commons/index.js";
import { DropdownButton } from "./../../../toolbars-ui/index.js";
import DividerSizePanel from "../modals/DividerSizePanel.js";
import { dividerSizeData } from "./dividerButtonsData.js";
const DividerSizeButton = ({ toolbarItem, dataHook, id }) => {
  const { isMobile, t } = useContext(RicosContext) || {};
  const modalService = useModalService();
  const isModalOpen = useModalState(getIsModalOpen(id));
  const [referenceElement, setReferenceElement] = useState(null);
  const getSelectedSize = () => toolbarItem?.attributes.nodeSize || DividerData_Width.LARGE;
  const selectedSize = dividerSizeData.find(({ commandKey }) => commandKey === getSelectedSize());
  const Icon = selectedSize?.icon || SizeMediumIcon;
  const closeModal = () => modalService.closeModal(id);
  const onSizeClick = (value) => {
    toolbarItem.commands?.click({ value });
    closeModal();
  };
  const onClick = () => {
    modalService.isModalOpen(id) ? closeModal() : modalService.openModal({
      Component: DividerSizePanel,
      id,
      componentProps: {
        getSelectedSize,
        onClick: onSizeClick
      },
      layout: isMobile ? "drawer" : "toolbar",
      positioning: { referenceElement, placement: "bottom" }
    });
  };
  return /* @__PURE__ */ React.createElement(
    DropdownButton,
    {
      dataHook,
      active: isModalOpen,
      onClick,
      setRef: setReferenceElement,
      Icon,
      tooltip: t("ButtonModal_Size_Section")
    }
  );
};
export {
  DividerSizeButton
};
//# sourceMappingURL=DividerSizeButton.js.map
